export var WrapMode;
(function (WrapMode) {
    WrapMode[WrapMode["Repeat"] = 0] = "Repeat";
    WrapMode[WrapMode["Clamp"] = 1] = "Clamp";
    WrapMode[WrapMode["Mirrored"] = 2] = "Mirrored";
})(WrapMode || (WrapMode = {}));
